import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 2rem;

  ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    column-gap: 25px;
    row-gap: 25px;
    padding: 0;

    li {
      font-size: 14px;
      letter-spacing: 0em;
      text-align: left;

      display: flex;
      justify-content: flex-start;

      width: 200px;

      .icon-container {
        width: 17px;
        height: 17px;
        padding-top: 2px;
        margin-right: 10px;
      }

      color: ${({ theme }) => theme.colors.textColor};

      svg {
        color: #289a00;
      }
    }

    @media (max-width: 1100px) {
      justify-content: center;
      width: 100%;
    }

    @media (max-width: 540px) {
      li {
        margin: 0;
      }
    }
  }
`;
